export function getButtonStyle(colorString: string | null): {
  buttonClass: string;
  colorStyle?: [string] | [string, string];
} {
  try {
    if (colorString === null) {
      return;
    }
    switch (colorString) {
      case 'Green':
        return { buttonClass: 'bg-green-button', colorStyle: ['#6F8D6F'] };
      case 'White (Green)':
        return { buttonClass: 'bg-white-green-button', colorStyle: ['#FFFFFF', '#6F8D6F'] };
      case 'Navy':
        return { buttonClass: 'bg-navy-button', colorStyle: ['#212741'] };
      case 'White (Navy)':
        return { buttonClass: 'bg-white-navy-button', colorStyle: ['#FFFFFF', '#212741'] };
      case 'Bordeaux':
        return { buttonClass: 'bg-bordeaux-button', colorStyle: ['#440909'] };
      case 'White (Bordeaux)':
        return { buttonClass: 'bg-white-bordeaux-button' };
      default:
        return { buttonClass: 'bg-green-button', colorStyle: ['#6F8D6F'] };
    }
  } catch (err) {
    console.error(err);
  }
}
